import { useState, useEffect } from "react";
import { Typography, Box, InputBase, Tooltip, IconButton } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseCustomersManagement } from "./UseCustomersManagement";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";

export default function CustomersManagement() {
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("Id", "Desc");
  let navigate = useNavigate();
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetCustomersList, SuspendCustomer } = UseCustomersManagement();
  const [productRes, setProductRes] = useState();
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    GetCustomersList(myPc, search, true, (customers) => {
      setProgress(false);
      setProductRes(customers);
    });
  }, [myPc]);

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      sortable: false,
      // hide: true,
    },
    {
      field: "firstName",
      width: 160,
      align: "center",
      headerName: "نام",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ cursor: "pointer" }}>
            {cellValues.row.firstName}
          </Typography>
        );
      },
    },
    {
      field: "lastName",
      headerName: "نام خانوادگی",
      width: 160,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.lastName}
          </Typography>
        );
      },
    },
    {
      field: "mobile",
      headerName: "موبایل",
      sortable: false,
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "genderTitle",
      headerName: "جنسیت",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.genderTitle}
          </Typography>
        );
      },
    },
    {
      field: "suspendTitle",
      headerName: "وضعیت",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.suspendTitle}
          </Typography>
        );
      },
    },
    {
      field: "تعلیق",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "تعلیق",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.suspend == 1 ? (
              <Tooltip title="عملیات تعلیق">
                <IconButton
                  onClick={() =>
                    setCheckState({
                      show: true,
                      suspend: false,
                      id: cellValues.row.id,
                      name:
                        "عدم تعلیق کاربر " +
                        cellValues.row.firstName +
                        " " +
                        cellValues.row.lastName,
                    })
                  }
                >
                  <LockIcon color="secondary" />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="عملیات تعلیق">
                <IconButton
                  onClick={() =>
                    setCheckState({
                      show: true,
                      suspend: true,
                      id: cellValues.row.id,
                      name:
                        " تعلیق کاربر " +
                        cellValues.row.firstName +
                        " " +
                        cellValues.row.lastName,
                    })
                  }
                >
                  <LockOpenIcon color="secondary" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              fullWidth
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "ارتباط با مشتری",
        childs: [{ name: msActiveMenu.pageTitle, url: "/customers" }],
      }}
    >
      {productRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={productRes.pageCondition.pageCount}
          rows={productRes.customers}
          paginationMode="server"
          page={productRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={productRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              isLtr: true,
              nofab: true,
              rowCount: productRes.pageCondition.totalItemCount,
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          sx={{
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "&  .MuiDataGrid-columnHeader:focus-within": {
              outline: "none",
            },
            "&  .MuiDataGrid-cell:focus-within ": {
              outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
            },
            width: "100% !important",
            "& .muirtl-s1v7zr-MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !Important",
            },
            "&  .MuiDataGrid-filterIcon": {
              display: "none",
            },
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
            "& .MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !important",
            },
            "& .red": {
              width: "100%",
              backgroundColor: "#ff9c9c !important",
            },
            "& .orange": {
              backgroundColor: "#FFC36E !important",
            },
          }}
          getRowClassName={(params) => {
            if (params.row.suspend == 1) {
              return "red";
            }
            if (params.row.suspend == 2) {
              return "orange";
            }
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          let state = {
            id: checkState.id,
            suspend: checkState.suspend,
          };
          setProgress(true);
          SuspendCustomer(state, () => {
            GetCustomersList(myPc, search, false, (customers) => {
              setProductRes(customers);
            });
          });
        }}
      />
    </Detail>
  );
}
